export const TRIAL_DURATION_TYPES = Object.freeze({
  weeks: 'Weeks',
  months: 'Months',
});
